import {
    apiRequest,
    pangkatDetail
} from "../../../../../services/adapters/kepegawaian/pangkatService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", pangkatDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository